import Vue from 'vue'
import App from './App'
import router from './router'
import Buefy from 'buefy'
import Store from './store.js'
import VueI18n from 'vue-i18n'
import '@mdi/font/css/materialdesignicons.css'
import {messages, browserLanguage} from './translations.js'

Vue.use(Buefy)

Vue.use(VueI18n)

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: browserLanguage,
  fallbackLocale: 'en',
  messages,
  silentFallbackWarn: true,
  silentTranslationWarn: true
})

// Used for integration tests with Cypress, set the localStorage
if (window.Cypress) {
  window.__store__= Store
}

new Vue({
  el: '#app',
  router,
  store: Store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js